import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IDangKyAnReponse } from "../../../models/response/thuc-don/IDangKyAnReponse";
import { IFoDangKyAnHocSinhActionTypes } from "../../action-types/thuc-don/IFoDangKyAnHocSinhActionTypes";
import { IFoDangKyAnHocSinhReducer } from "../../page-state-model/thuc-don/IFoDangKyAnHocSinhReducer";

const iniState: IFoDangKyAnHocSinhReducer = {
  status: ePageBaseStatus.is_not_initialization,
  foDangKyAnHocSinhs: [],
  editingData: undefined,
  isShowEditModal: false,
  isShowImportModal: false,
  dangKyAnImports: {} as IDangKyAnReponse,
};

export const foDangKyAnHocSinhReducer = (
  state: IFoDangKyAnHocSinhReducer = iniState,
  action: IFoDangKyAnHocSinhActionTypes
): IFoDangKyAnHocSinhReducer => {
  switch (action.type) {
    case "DANG_KY_AN_HOC_SINH_LOAD_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "DANG_KY_AN_HOC_SINH_LOAD_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        foDangKyAnHocSinhs: action.payload,
      };
    case "DANG_KY_AN_HOC_SINH_LOAD_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        foDangKyAnHocSinhs: [],
      };
    case "DANG_KY_AN_HOC_SINH_LOAD_BY_COSO_NAMHOC_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "DANG_KY_AN_HOC_SINH_LOAD_BY_COSO_NAMHOC_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        foDangKyAnHocSinhs: action.payload,
      };
    case "DANG_KY_AN_HOC_SINH_LOAD_BY_COSO_NAMHOC_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
        foDangKyAnHocSinhs: [],
      };
    case "DANG_KY_AN_HOC_SINH_SHOW_EDIT_MODAL":
      return {
        ...state,
        editingData: action.payload,
        isShowEditModal: true,
      };
    case "DANG_KY_AN_HOC_SINH_CLOSE_EDIT_MODAL":
      return {
        ...state,
        editingData: undefined,
        isShowEditModal: false,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload,
        isShowEditModal: false,
        editingData: undefined,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "DANG_KY_AN_HOC_SINH_SHOW_IMPORT_MODAL":
      return {
        ...state,
        isShowImportModal: true,
      };
    case "DANG_KY_AN_HOC_SINH_CLOSE_IMPORT_MODAL":
      return {
        ...state,
        isShowImportModal: false,
        status: ePageBaseStatus.is_need_reload,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_IMPORT_START":
      return {
        ...state,
        status: ePageBaseStatus.is_saving,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_IMPORT_SUCCESS":
      return {
        ...state,
        dangKyAnImports: action.payload,
        status: ePageBaseStatus.is_need_reload,
      };
    case "DANG_KY_AN_HOC_SINH_SAVE_IMPORT_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed,
      };
    case "DANG_KY_AN_HOC_SINH_DELETE_START":
      return {
        ...state,
        status: ePageBaseStatus.is_loading
      }
    case "DANG_KY_AN_HOC_SINH_DELETE_SUCCESS":
      return {
        ...state,
        status: ePageBaseStatus.is_need_reload
      }
    case "DANG_KY_AN_HOC_SINH_DELETE_ERROR":
      return {
        ...state,
        status: ePageBaseStatus.is_completed
      };
    default:
      return state;
  }
};
